import * as React from 'react'
import { MemoryRouter } from 'react-router'

export default (story: () => React.ReactNode) => (
  <MemoryRouter>{story()}</MemoryRouter>
)
